<template>
  <div class="footer">
  <!-- <div :class="isIndex ? 'footer footerIndex' : 'footer'"> -->
    <div class="footer_cont">
      <img class="logo" src="https://oss.duodians.com/lambda/office_web/footer/logo.png">
      <div class="text_cont"> 
        <p class="title">解决方案</p>
        <p class="text" @click="goToLink('/solution')">EMS智慧能源管理系统</p>
        <p class="text" @click="goToLink('/platform')">储能电池数据监测平台</p>
        <p class="text" @click="goToLink('/virtualPower')">虚拟电厂</p>
      </div>
      <div class="text_cont"> 
        <p class="title">核心技术</p>
        <p class="text" @click="goToLink('/energy')">Energy AI</p>
        <p class="text" @click="goToLink('/battery')">Battery AI</p>
        <p class="text" @click="goToLink('/bigData')">大数据</p>
        <p class="text" @click="goToLink('/product')">物联网</p>
      </div>
      <div class="text_cont"> 
        <p class="title">关于我们</p>
        <p class="text" @click="goToLink('/about')">品牌介绍</p>
        <!-- <p class="text" @click="goToLink('/about')">渠道合作</p> -->
      </div>
      <div class=""> 
        <p class="title">联系我们</p>
        <p class="text">
          <i class="el-icon-message" ></i>
          152-0197-8620
        </p>
        <div class="code_cont">
          <div class="wechart">
            <img class="icon_img" src="https://oss.duodians.com/lambda/office_web/footer/icon_wechart.png" alt="">
            <div class="wechart_hover_cont">
              <img src="https://oss.duodians.com/lambda/office_web/footer/qrcode_15201978620.png" alt="">
              <!-- <p class="text">微信</p> -->
              <i class="triangle el-icon-caret-bottom"></i>
            </div>
          </div>
          <!-- <div class="applets">
            <img class="icon_img" src="https://oss.duodians.com/lambda/office_web/footer/icon_applets.png" alt="">
            <div class="applets_hover_cont">
              <img src="https://oss.duodians.com/lambda/office_web/footer/icon_code1.jpg" alt="">
              <p class="text">小程序</p>
              <i class="triangle el-icon-caret-bottom"></i>
            </div>
          </div> -->
        </div>
      </div>
    </div>
    <div class="footer_right">
       <span>Copyright &#169 2025 上海哆点信息科技有限公司 All Rights Reserved.</span>
        <img class="img" src="https://oss.duodians.com/lambda/office_web/ICPlogo.png" alt="">
        <a href="https://beian.miit.gov.cn/" target="_blank">沪ICP备20000514号-1
</a>
    </div>
    
  </div>
</template>
<script>
import api from '../../api/index'
export default {
  data() {
    return {
      dialogFormVisible: false,
      form: {
        phone: "",
      },
      index: 0,
      isIndex: false,
      logoUrl: 'https://oss.duodians.com/lambda/office_web/footer/logo.png'
    }
  },
  components: {},
  watch:{
    $route:{
      immediate:true,
      handler(){
        //地址栏发生改变，该函数会执行
        // this.handleSetIndex(window.location.hash.split('/')[1])
      }
    }
  },
  created() {
    const {name} = this.$route
    // this.handleSetIndex(name)
  },
  methods: {
    handleSetIndex(name) {
      this.isIndex = name === 'index'
      this.logoUrl = name === 'index'
      ? 'https://ecare-health.oss-cn-beijing.aliyuncs.com/www/footer/logo_yellow.png'
      : 'https://ecare-health.oss-cn-beijing.aliyuncs.com/www/footer/logo.png'
    },
    goToLink(url) {
      this.$router.push({ path: url })
    }
  }

}
</script>
<style lang='less' scoped>
.footer {
  background: url('https://oss.duodians.com/lambda/office_web/footer/footer_bg.jpg');
  background-size: 100% 100%;
  height: 420px;
  .footer_cont{
    width: 1300px;
    margin: 0 auto;
    display: flex;
    padding-top: 80px;
    height: 337px;
    .logo{
      width: 115px;
      height: 55px;
      margin-right: 350px;
    }
    .text_cont{
      margin-right: 75px;
    }
    .title{
      font-size: 20px;
      font-family: SourceHanSansCN, SourceHanSansCN-Bold;
      font-weight: 700;
      color: #fff;
      line-height: 21px;
      text-align: left;
      margin-bottom: 38px;
    }
    .text{
      margin-top: 10px;
      font-size: 18px;
      font-family: PingFangSC, PingFangSC-Regular;
      font-weight: 400;
      text-align: left;
      color: rgba(255,255,255,.65);
      line-height: 30px;
      cursor: pointer;
    }
    .code_cont{
      margin-top: 33px;
      display: flex;
      .wechart{
        cursor: pointer;
        background: rgba(255,255,255, .12);
        width: 64px;
        height: 40px;
        border-radius: 8px;
        margin-right: 20px;
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;
        .icon_img{
          width: 23px;
        }
      }
      .wechart:hover{
        background: #4cddbd;
        .wechart_hover_cont{
          display: block;
        }
      }
      .applets{
        cursor: pointer;
        width: 64px;
        height: 40px;
        background: rgba(255,255,255, .12);
        border-radius: 8px;
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;
        .icon_img{
          width: 18px;
        }
      }
      .applets:hover{
        background: #ffcd00;
        .applets_hover_cont{
          display: block;
        }
      }
      .wechart_hover_cont, .applets_hover_cont{
        display: none;
        position: absolute;
        bottom: 50px;
        width: 150px;
        height: 150px;
        background: #ffffff;
        border-radius: 8px;
        box-shadow: 0px 2px 10px 0px rgba(0,0,0,0.20); 
        padding: 13px 0;
        text-align: center;
        img{
          margin-bottom: 10px;
          width:120px;
        }
        .text{
          font-size: 14px;
          font-family: PingFangSC, PingFangSC-Medium;
          font-weight: 500;
          color: #464155;
          line-height: 20px;
          text-align: center;
        }
        .triangle{
          color: #fff;
          font-size: 14px;
          position: absolute;
          bottom: -9px;
          left:65px;
        }
      }
    }
  }
  .footer_right{
    border-top: 2px solid rgba(255,255,255,.1);
    height: 80px;
    font-size: 24px;
    font-family: PingFangSC, PingFangSC-Regular;
    font-weight: 400;
    text-align: center;
    color: rgba(255,255,255,.6);
    line-height: 80px;
    .img{
      width:15px;
      margin: 0 7px 0 49px;
    }
  }
}
.footerIndex{
  background: #fff;
  margin-top: -120px;
  .footer_cont{
    .title{
      color: #000;
    }
    .text{
      color: rgba(0,0,0,.65);
    }
  }
  .footer_right{
    border-top: 2px solid rgba(35,35,46,.1);
    color:rgba(70,65,84,1);
  }
}
</style>


// WEBPACK FOOTER //
// src/components/dd_footer/footer.vue